import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = ["title"]

import { ref, watch, onMounted, reactive } from "vue"
import { Tooltip, Popover, Form, FormItem, RadioGroup, Checkbox, Button } from 'ant-design-vue';
import { useTableContext } from '../../hooks/useTableContext';
import type { orderParamaItem } from "../../types/"
import { cloneDeep } from 'lodash-es';
import { useI18n } from '@/hooks/useI18n';



export default /*@__PURE__*/_defineComponent({
  __name: 'order-param',
  emits: ["unionChange", "orderConfirm", "orderCancel"],
  setup(__props, { emit: __emit }) {

const table = useTableContext();
const defaultOrderParama = cloneDeep<orderParamaItem[]>(table.OrderParam);
let tableOrderParama = ref<orderParamaItem[]>([]);

const emit = __emit
const union = ref(false)
const form = reactive({})

const visible = ref<boolean>(false);

const { t } = useI18n();
watch(union, (val) => {
  emit('unionChange', val)
});

onMounted(() => {
  _InitData()
})

const _InitData = function () {
  //将父组件传递进来的数据进行初始化
  tableOrderParama.value = cloneDeep(defaultOrderParama) //先将父组件的数值取过来
  for (let i = 0; i < table.columns.length; i++) {
    for (let j = 0; j < tableOrderParama.value.length; j++) {
      if (tableOrderParama.value[j].OrderByFieldName == table.columns[i].dataIndex) {
        if (!tableOrderParama.value[j].FieldName) {
          //如果没有配置的话，则从列文件中查找
          //@ts-ignore
          tableOrderParama.value[j].FieldName = table.columns[i].title
        }
        //初始化原始查询方式
        form[tableOrderParama.value[j].OrderByFieldName] = tableOrderParama.value[j].OrderType
      }
    }
  }
}

const plainOptions = [
  { label: t('component.table.Ascending'), value: 'Ascending' },
  { label: t('component.table.Descending'), value: 'Descending' },
]

const handleConfirm = function () {
  emit("orderConfirm", form, union);
  emit("orderCancel", 1);
  visible.value = false
}
const handleCancel = function () {
  _InitData();
  union.value = false;
  emit("orderCancel", 1);
  visible.value = false
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Tooltip), { placement: "top" }, {
    title: _withCtx(() => [
      _createElementVNode("span", null, _toDisplayString(_ctx.$t('component.table.settingOrder')), 1)
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(Popover), {
        placement: "bottomLeft",
        trigger: "click",
        open: visible.value,
        "onUpdate:open": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event))
      }, {
        content: _withCtx(() => [
          _createVNode(_unref(Form), {
            model: form,
            name: "basic",
            "label-col": { span: 8 },
            autocomplete: "off"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tableOrderParama), (item, index) => {
                return (_openBlock(), _createBlock(_unref(FormItem), {
                  key: index,
                  label: item.FieldName,
                  name: item.FieldName
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(RadioGroup), {
                      value: form[item.OrderByFieldName],
                      "onUpdate:value": ($event: any) => ((form[item.OrderByFieldName]) = $event),
                      options: plainOptions
                    }, null, 8, ["value", "onUpdate:value"])
                  ]),
                  _: 2
                }, 1032, ["label", "name"]))
              }), 128)),
              _createVNode(_unref(FormItem), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(Checkbox), {
                    checked: union.value,
                    "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((union).value = $event))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('component.table.union')), 1)
                    ]),
                    _: 1
                  }, 8, ["checked"]),
                  _createVNode(_unref(Button), {
                    size: "small",
                    onClick: handleConfirm
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('component.table.confirm')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(Button), {
                    size: "small",
                    onClick: handleCancel
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('component.table.cancel')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        default: _withCtx(() => [
          (union.value == true)
            ? (_openBlock(), _createElementBlock("i", {
                key: 0,
                class: "icon-random",
                title: _ctx.$t('component.table.union'),
                style: {"color":"#555555"}
              }, null, 8, _hoisted_1))
            : _createCommentVNode("", true),
          (union.value == false)
            ? (_openBlock(), _createElementBlock("i", {
                key: 1,
                class: "icon-sort",
                title: _ctx.$t('component.table.union'),
                style: {"color":"#555555"}
              }, null, 8, _hoisted_2))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["open"])
    ]),
    _: 1
  }))
}
}

})